import { Component, Vue, Watch } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import { debounce } from '@/utils/util'
const debounceSearch = debounce(300)

@Component({})
export default class CompanySearchTree extends Vue {
	public companyResult: any = []
	public companySearchValue: string = ''
	// 是否需要“全部”选项
	public needQuanBu = true
	public currentTree: any = {}

	public setCompanyAsTree() {
		if (this.needQuanBu) {
			this.companyResult = [
				{
					value: ' ',
					key: ' ',
					title: '全部',
					isLeaf: true,
				},
			].concat(this.currentTree)
		} else {
			this.companyResult = this.currentTree
		}
	}

	public searchCompany(val: string) {
		debounceSearch(() => {
			if (!val) {
				this.setCompanyAsTree()
				return
			}
			TaskApi.searchCompany(val.trim()).then((res: any) => {
				this.companyResult = res.data.map((item: any) => {
					return {
						isLeaf: true,
						key: item.companyId,
						title: item.companyName,
						value: item.companyId,
					}
				})
			})
		})
	}

	public initCompanyTree() {
		this.$store.dispatch('setting/initCompanyTree').then((res: any) => {
			this.currentTree = this.$store.state.setting.companyTree
			this.setCompanyAsTree()
			this.$emit('initTreeCb')
		})
	}

	public activated() {
		// this.initCompanyTree()
	}

	public created() {
		this.initCompanyTree()
	}
}
